export default new Promise((resolve) => {
  const googleURL = `https://maps.googleapis.com/maps/api/js?key=${
    import.meta.env.VITE_GOOGLE_API_KEY
  }&libraries=drawing,places,geometry,maps&v=beta`
  const script = document.createElement('script')
  script.src = googleURL
  document.head.appendChild(script)
  script.onload = () => {
    resolve(window['google'])
  }
})
